<template>
  <div>
    <el-container>
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
  </div>
</template>

<script>

  export default {
    name: 'HeadlessLayout',
  };
</script>

<style lang="scss" scoped>
  header{
    padding: 0 !important;
  }
  .el-main{
    padding: 0;
  }
</style>


// WEBPACK FOOTER //
// src/templates/HeadlessLayout.vue